"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const TooltipContent = styled_components_1.default.div `
  box-sizing: border-box;
  min-height: 24px;
  min-width: 24px;
  max-height: ${({ theme }) => parseInt(theme.maxHeight, 10) - parseInt(theme.padding, 10) * 2}px;
  overflow-x: auto;
  word-break: break-word;
`;
exports.default = TooltipContent;
